import { render, staticRenderFns } from "./TextToSpeechSimple.vue?vue&type=template&id=16dcee6a&scoped=true&"
import script from "./TextToSpeechSimple.vue?vue&type=script&lang=js&"
export * from "./TextToSpeechSimple.vue?vue&type=script&lang=js&"
import style0 from "./TextToSpeechSimple.vue?vue&type=style&index=0&id=16dcee6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dcee6a",
  null
  
)

export default component.exports